<template>
  <div
    class="pt-0"
    :class="{'d-flex flex-column col-2': !$vuetify.breakpoint.mdAndDown, 'container': !$vuetify.breakpoint.mdAndDown }"
  >
    <v-menu
      v-if="$vuetify.breakpoint.mdAndDown"
      v-model="filterMenu"
      max-width="300"
      :close-on-click="false"
      :close-on-content-click="false"
    >
      <template
        v-slot:activator="{ on }"
      >
        <v-btn
        style="z-index: 9;"
        absolute
        top
        left
        icon
        small
        @click="handleVisibility.apply(null, [$event, on])"
      >
        <v-icon
          size="15px"
        >
          {{ filterVisibility ? 'fas fa-times' : 'fas fa-filter' }}
        </v-icon>
      </v-btn>
      </template>
      <v-card
        class="pa-1"
        :class="{'filter--visibility--hidden': !filterVisibility}"
      >
        <v-container
          no-gutters
        >
          <v-row
          no-gutters
          >
            <v-col
              cols="12"
            >
              <slot
              >

              </slot>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-menu>
    <v-col
      cols="12"
      class="pa-0 overflow-y-auto filters--slot"
      v-else
      >
        <slot>

        </slot>
      </v-col>
</div>
</template>

<script>
  export default {
    name: 'ShipmentsGroupByDayFiltersWrapper',
    data () {
      return {
        filterMenu: true,
        filterVisibility: false
      }
    },
    methods: {
      handleVisibility (evt, on) {
        this.filterVisibility = !this.filterVisibility
      }
    }
  }
</script>

<style lang="scss" scoped>
 .filter--visibility--hidden {
    position: absolute;
    left: -1000px;
 }
 .container {
   position: relative;
  .filters--slot {
    position: absolute;
    top: 0; bottom: 0; left: 0; right: 0;
    overflow: auto;
  }
 }
</style>
